import { Capacitor } from "@capacitor/core";
import { publicOrigin } from "./publicOrigin";

const isNative = () => Capacitor.isNativePlatform();

// Relative hrefs ("/legal/terms") must point at the PUBLIC site, never at the
// WebView's internal origin (capacitor://localhost). Yalola pages also carry the
// current UI language: Safari in-app is a fresh session (no localStorage), so
// without it the legal page would open in the device language.
export const toAbsoluteUrl = (href) => {
  if (/^[a-z][a-z0-9+.-]*:/i.test(href)) return href;
  const url = new URL(href, `${publicOrigin()}/`);
  const lang = (document.documentElement.lang || "").slice(0, 2);
  if (lang && !url.searchParams.has("lang")) url.searchParams.set("lang", lang);
  return url.toString();
};

export async function openExternal(href) {
  const url = toAbsoluteUrl(href);
  if (isNative()) {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url, toolbarColor: "#0A0D0C" });
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

// Native shells only: every <a target="_blank"> opens in the in-app browser
// (SFSafariViewController / Chrome Custom Tab). The iOS WKWebView has no window
// handler for target=_blank, so those taps did nothing (CGU / Confidentialité).
export function initNativeExternalLinks() {
  if (!isNative()) return;
  document.addEventListener("click", (e) => {
    if (e.defaultPrevented || e.button !== 0) return;
    const a = e.target?.closest?.("a[href][target=_blank]");
    if (!a) return;
    const href = a.getAttribute("href");
    if (!href || href.startsWith("#") || /^(mailto|tel|sms|whatsapp|javascript):/i.test(href)) return;
    e.preventDefault();
    openExternal(href).catch(() => { window.location.href = toAbsoluteUrl(href); });
  });
}

export default initNativeExternalLinks;
